import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-payment-method-dropdown',
  templateUrl: './payment-method-dropdown.component.html',
  styleUrls: ['./payment-method-dropdown.component.scss']
})
export class PaymentMethodDropdownComponent implements OnInit {

  @Input() dropDownConfig: any;
  DEFAUL_CONFIG = {
    inputAppearance: '',
    wrapClass: '',
    selectPlaceHolder: 'Select',
    list: {},
    selectedOption: ''
  };
  @Output() dataEmit = new EventEmitter();

  searchForm: FormGroup;
  searchText: FormControl;
  filteredList;


  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.dropDownConfig = { ...this.DEFAUL_CONFIG, ...this.dropDownConfig };
    this.filteredList = this.dropDownConfig?.list;
    this.searchForm = new FormGroup({
      searchText: this.searchText = new FormControl(''),
    });
  }

  search(value) {
    this.filteredList = this.util.filterObject(this.dropDownConfig?.list, value);
  }

  resetSearch() {
    this.search('');
  }

}
